module.exports = __webpack_public_path__ + "static/33gde-6767202bb3106b8653d9af83959dcef2.gif";